import { jsx as _jsx } from "react/jsx-runtime";
import { FlexContainer } from './FlexContainer';
export const ButtonRow = ({ children, wrap, ...spacing }) => {
    return (_jsx(FlexContainer, { gap: '1/2', wrap: wrap, ...spacing, children: children }));
};
